export default __webpack_public_path__ + "static/media/dropbox.e70e15aa.svg";